export const COHORTS_SLICE_KEY = 'cohorts';
export const COHORTS_BASE_PATH = 'cohort-profile';
